import o from"./_getNative.js";import r from"./_root.js";var t=o(r,"Promise");export{t as default};
//# sourceMappingURL=_Promise.js.map
